export const DEFAULT_LOCALE = {
  locale: 'fi-FI',
  language: 'fi',
  label: 'Suomeksi',
} as const;

export const localesMap = {
  fi: DEFAULT_LOCALE,
  en: {
    locale: 'en-GB',
    language: 'en',
    label: 'In English',
  },
} as const;

export const locales = Object.values(localesMap);
export const languages = locales.map((locale) => locale.language);

export type Localization = (typeof locales)[number];

export const languageRegex = new RegExp(
  `/(${locales.map((x) => x.language).join('|')})/`
);

export const defaultAvailableLanguage = {
  value: 'finnish',
  shortValue: 'Fin',
  key: 'FI',
} as const;

export const availableLanguages = [
  defaultAvailableLanguage,
  {
    value: 'english',
    shortValue: 'Eng',
    key: 'EN',
  },
] as const;

export const availableInfoLanguages = [
  {
    value: 'arabic',
    shortValue: 'Ara',
    key: 'AR',
  },
  {
    value: 'english',
    shortValue: 'Eng',
    key: 'EN',
  },
  {
    value: 'finnish',
    shortValue: 'Fin',
    key: 'FI',
  },
  {
    value: 'russian',
    shortValue: 'Rus',
    key: 'RU',
  },
  {
    value: 'somali',
    shortValue: 'Som',
    key: 'SO',
  },
  {
    value: 'swedish',
    shortValue: 'Swe',
    key: 'SV',
  },
  {
    value: 'turkish',
    shortValue: 'Tur',
    key: 'TR',
  },
  {
    value: 'estonia',
    shortValue: 'Est',
    key: 'ES',
  },
  {
    value: 'french',
    shortValue: 'Fra',
    key: 'FR',
  },
] as const;
